import { fetch } from '@utils/utils';

export const getColumnSettings = ({ addError }) => async (): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/settings/user/`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    let json: any = {};
    if (response.status !== 204) {
      json = await response.json();
    }
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const postColumnSettings = ({ addSuccess, addError }): any => async (body: any): Promise<any> => {
  try {
    const response: any = await fetch('/metropolis/api/settings/user/', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    if (response.ok) {
      const json = await response.json();
      addSuccess('Nastavení sloupců uloženo');
      return json;
    }
    addError('Uložení se nezdařilo');
    return {};
  } catch (err) {
    addError(err.message);
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/columnSettings/_columnSettingsActions.ts